import { SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';

export enum TextColorProps {
  Primary = 'primary',
  Secondary = 'secondary',
  Inherit = 'inherit',
}
export interface TabsProps {
  name: string;
  tabTitles: Array<string>;
  children: Array<ReactNode>;
  textColor?: TextColorProps;
  TabIndicatorProps?: object;
  isCustomColor?: boolean;
  onTabChange?: (tabType: string) => void;
  variant?: 'standard' | 'scrollable' | 'fullWidth';
  scrollButtons?: boolean | 'auto';
  /**
   * Forwarded to MUI Tabs. When `true`, the scrollable tab arrows are
   * shown on mobile/touch devices as well as desktop — MUI defaults to
   * hiding them on touch. Use together with `scrollButtons="auto"` or
   * `scrollButtons={true}` to get on-screen scroll indicators on mobile.
   */
  allowScrollButtonsMobile?: boolean;
  /** Forwarded to the MUI Tabs root — use for container-level overrides
   *  like position, floating scroll buttons, etc. */
  sx?: SxProps<Theme>;
  tabSx?: object;
  swipeable?: boolean;
  keepMounted?: boolean;
}
